module.exports = __webpack_public_path__ + "static/media/whiteArrowRight.4645c285.svg";